import { Tooltip } from 'antd'

const ELLIPSIS = '...'
const TAIL_LENGTH = 8
export const DEFAULT_LENGTH = 30

export enum TruncatePosition {
  START = 'start',
  MIDDLE = 'middle',
  END = 'end',
}

export function truncatePath(
  path: string,
  length = DEFAULT_LENGTH,
  position: TruncatePosition = TruncatePosition.MIDDLE
): string {
  if (!path) return ''
  if (path.length <= length) return path
  if (length <= ELLIPSIS.length) return path

  switch (position) {
    case TruncatePosition.START: {
      const headChars = 1
      const suffixLength = length - headChars - ELLIPSIS.length
      const head = path.slice(0, headChars)
      const tail = path.slice(-suffixLength)
      return `${head}${ELLIPSIS}${tail}`
    }
    case TruncatePosition.END: {
      const prefixLength = length - ELLIPSIS.length
      const prefix = path.slice(0, prefixLength)
      return `${prefix}${ELLIPSIS}`
    }
    default: {
      const charsToShow = length - ELLIPSIS.length
      const headChars = Math.ceil(charsToShow / 2)
      const tailChars = Math.floor(charsToShow / 2)
      const head = path.slice(0, headChars)
      const tail = path.slice(path.length - tailChars)
      return `${head}${ELLIPSIS}${tail}`
    }
  }
}

export function truncatePathWithTooltip(
  path: string,
  length = DEFAULT_LENGTH,
  position: TruncatePosition = TruncatePosition.MIDDLE
): React.ReactNode {
  const truncated = truncatePath(path, length, position)
  if (truncated === path) return path
  return (
    <Tooltip title={path} placement="bottom">
      {truncated}
    </Tooltip>
  )
}

export const truncate = (
  text: string,
  length = DEFAULT_LENGTH
): React.ReactNode => {
  if (!text) return
  if (text.length <= length) return text

  return (
    <>
      {text.slice(0, length / 3)}...{text.slice(-TAIL_LENGTH)}
    </>
  )
}

export const truncateWithTooltip = (
  text: string,
  length = DEFAULT_LENGTH
): React.ReactNode => {
  if (!text) return
  if (text.length <= length) return text

  return (
    <Tooltip title={text} placement="bottom">
      {text.slice(0, length / 3)}...{text.slice(-TAIL_LENGTH)}
    </Tooltip>
  )
}

export const truncateStart = (text: string, length = 30): React.ReactNode => {
  if (!text) return
  if (text.length <= length) return text
  return (
    <>
      {text.slice(0, length / 3)}...{text.slice(-TAIL_LENGTH)}
    </>
  )
}
export const truncateStartWithTooltip = (
  text: string,
  length = DEFAULT_LENGTH
): React.ReactNode => {
  if (!text) return
  if (text.length <= length) return text
  return (
    <Tooltip title={text} placement="bottom">
      {text.slice(0, length / 3)}...
    </Tooltip>
  )
}
